import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ActivityStepper from 'containers/Dashboard/components/ActivityStepper';
import {Activity} from 'APIs/letrusAPI/activities/types';
import FocusModeTimer from 'components/FocusModeTimer';
import styles from './QuestionnaireHeader.module.scss';

interface QuestionnaireHeaderProps {
  name?: string;
  onGoBack: () => void;
  learningPath?: Activity;
  isActive?: boolean;
  remainingSeconds?: number;
  effectiveTimeSeconds?: number;
  isExpired?: boolean;
}

function QuestionnaireHeader({
  name,
  onGoBack,
  learningPath,
  isActive,
  remainingSeconds = 0,
  effectiveTimeSeconds = 0,
  isExpired = false,
}: QuestionnaireHeaderProps) {
  return (
    <section className={styles.header} data-testid="questionnaire-header">
      <div className={styles.questionnaireInfo}>
        <button
          type="button"
          aria-label="Voltar"
          data-testid="returnButton"
          onClick={onGoBack}
        >
          <FontAwesomeIcon icon="angle-left" size="xl" />
        </button>

        <div>
          {learningPath && (
            <h2 className={styles.title}>{learningPath?.name}</h2>
          )}
          <p className={styles.subtitle}>{name}</p>
        </div>
      </div>

      {learningPath && (
        <div className={styles.stepperWrapper}>
          <ActivityStepper activity={learningPath} />
        </div>
      )}

      {isActive && (
        <div className={styles.headerRight}>
          <FocusModeTimer
            remainingSeconds={remainingSeconds}
            effectiveTimeSeconds={effectiveTimeSeconds}
            isExpired={isExpired}
            isInHeader
          />
        </div>
      )}
    </section>
  );
}

export default QuestionnaireHeader;
